/* istanbul ignore file */
import dynamic from 'next/dynamic';

import { ContentBlockRenderer } from 'src/types/Block';
import { ContentstackSection } from 'src/types/Contentstack';
import { Transformer } from 'src/types/Transformer';

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<Record<string, never>> = dynamic(() =>
  import('src/components/blocks/PreviewErrorBlock').then((mod) => mod.PreviewErrorBlock),
);

export const createPreviewErrorTransformer = (errorMessage: string) => {
  const previewErrorTransformer: Transformer<ContentstackSection, Record<string, never>> = ({
    _metadata,
  }) => ({
    uid: _metadata.uid,
    props: {},
    errors: [{ message: errorMessage }],
  });

  return previewErrorTransformer;
};
